// The check pings at the meeting's cadence so a firewall sees the same idle gaps the meeting has.
export const SIGNALLING_KEEPALIVE_MS = 25_000;
